import React from "react";
import { Helmet } from "react-helmet-async";
import { withRouter } from "react-router-dom";
import withDefaultParams from "Services/withDefaultParams";
import { SEO_QUERY } from "Services/queries";
import { useQuery } from "react-apollo";
import queryString from "query-string";

const withSEOv2 = props => {
    let query = queryString.parse(props.location.search);
    if (!!query.provider_id) {
        query.providerId = query.provider_id;
    }

    // Убрать все пробельные символы в свойствах query
    for (let key in query) {
        query[key] = query[key].replace(/\s/g,"");
    }

    const { data } = useQuery(SEO_QUERY, {
        variables: props.route.seo({
            ...props.match.params,
            ...query,
        }),
    });

    const seoData = data?.seoV2;

    let { children, ...rest } = props;
    let childrenPrimary = React.cloneElement(props.children, {
        ...rest,
        seoData: seoData,
        matchProps: rest,
    });
    if (props.withBannerText) {
        childrenPrimary = React.cloneElement(childrenPrimary, {
            bannerText: seoData && seoData.h1,
            bannerTextAfter: seoData && seoData.h1After,
        });
    }

    return (
        <>
            <Helmet>
                <meta
                    name="description"
                    content={
                        seoData && seoData.description
                            ? seoData.description
                            : ""
                    }
                />
                <meta
                    name="keywords"
                    content={
                        seoData && seoData.keywords ? seoData.keywords : ""
                    }
                />
                <title>{seoData && seoData.title ? seoData.title : ""}</title>
            </Helmet>
            {childrenPrimary}
        </>
    );
};

export default withRouter(withDefaultParams(withSEOv2));
